function skipped(ctx, value) {
    return ctx.p0.skip || ctx.p1.skip ? value : undefined;
}
function last(ctx, length, value) {
    return ctx.p1DataIndex === (length - 1) ? value : undefined;
}

export default {
    skipped: skipped,
    last: last
}